import { boardGameProducts } from '../Assets/Product_Info/boardGameProducts'
import { MTGProducts } from '../Assets/Product_Info/MTGProducts'
import { OnePieceProduct } from '../Assets/Product_Info/OnePieceProduct'
import { DragonShieldProducts } from '../Assets/Product_Info/DragonShieldProducts'
import { LuckDragonProducts } from '../Assets/Product_Info/LuckDragonProducts'
import { SleeveKingsProducts } from '../Assets/Product_Info/SleeveKingsProducts'
import { ArmyPainterProducts } from '../Assets/Product_Info/ArmyPainterProducts'
import { GradedGuardProducts } from '../Assets/Product_Info/GradedGuardProducts'
import { DiceProducts } from '../Assets/Product_Info/DiceProducts'
import { RiftboundProduct } from '../Assets/Product_Info/RiftboundProducts'

export {
  boardGameProducts,
  MTGProducts,
  OnePieceProduct,
  DragonShieldProducts,
  LuckDragonProducts,
  SleeveKingsProducts,
  ArmyPainterProducts,
  GradedGuardProducts,
  DiceProducts,
  RiftboundProduct,
}

const allProducts = [
  ...boardGameProducts,
  ...MTGProducts,
  ...OnePieceProduct,
  ...DragonShieldProducts,
  ...LuckDragonProducts,
  ...SleeveKingsProducts,
  ...ArmyPainterProducts,
  ...GradedGuardProducts,
  ...DiceProducts,
  ...RiftboundProduct,
]

export default allProducts

const _idSet = {}
const _categoryIdMap = {}

const _register = (arr, category) => {
  for (const p of arr) {
    _idSet[p.id] = p
    _categoryIdMap[p.id] = category
  }
}

_register(boardGameProducts, 'boardGame')
_register(MTGProducts, 'mtg')
_register(OnePieceProduct, 'onePiece')
_register(DragonShieldProducts, 'dragonShield')
_register(LuckDragonProducts, 'luckDragon')
_register(SleeveKingsProducts, 'sleeveKings')
_register(ArmyPainterProducts, 'armyPainter')
_register(GradedGuardProducts, 'gradedGuard')
_register(DiceProducts, 'dice')
_register(RiftboundProduct, 'riftbound')


export const findProductById = (id) => _idSet[id] || null

export const getProductCategory = (id) => _categoryIdMap[id] || null

const ACCESSORY_CATEGORIES = new Set([
  'dragonShield', 'luckDragon', 'sleeveKings', 'armyPainter', 'gradedGuard', 'dice',
])

const TCG_CATEGORIES = new Set([
  'mtg', 'onePiece', 'sleeveKings', 'armyPainter', 'gradedGuard', 'dice', 'riftbound',
])

export const isAccessory = (id) => ACCESSORY_CATEGORIES.has(_categoryIdMap[id])

export const isTCG = (id) => TCG_CATEGORIES.has(_categoryIdMap[id])



